export default __webpack_public_path__ + "static/media/guide-ca.0bd0b70a.svg";